<div class="grid align-center padding-horizontal-medium padding-bottom-medium document-template padding-vertical-xxbig">
  <div class="cell cell-large-col-span-6 cell-medium-col-span-8">
    <div class="display-large text-surface-decorative"><span>Finalise your<br></span><span>quote</span></div>
    <div class="text-large text-blackMatte margin-vertical-medium">You'll need to confirm the answers you've previously given and answer any extra questions so we know the details that we're using are correct</div>
    <button mat-flat-button *ngFor="let button of data.settings?.buttons" color="primary" type="button" class="margin-bottom-small" (click)="startQuoteEvent.emit(button.link)">Continue quote</button>

    <div
      id="trustbox-rating-1"
      class="trustpilot-widget margin-bottom-medium"
      data-locale="en-GB"
      data-style-height="40px"
      data-style-width="100%"
      data-theme="light"
      data-stars="3,4,5"
      data-tags="SelectedReview"
      data-schema-type="Organization">
    </div>
  </div>

  <div class="cell cell-large-col-span-6 cell-medium-col-span-8">
    <div class="product-summary-card">
      <div class="padding-medium">
        <div class="flex margin-bottom-small">
          <div class="flex-grow text-left flex flex-content-center flex-wrap margin-right-xsmall">
            <h2 class="text-blackMatte margin-none">{{ destinationHeading(data.settings.card.mapping) }}</h2>
          </div>
          <open-svg-icon name="{{ data.settings.card.icon }}" class="medium"></open-svg-icon>
        </div>
        
        <div class="flex margin-bottom-xxsmall" *ngFor="let lineItem of data.settings.card.content">
          <div class="flex-shrink">
            <h4 class="text-blackMatte margin-none">{{ lineItem.heading }}</h4>
          </div>
          <div class="flex-grow">
            <p class="text-right text-darkGray margin-none">{{ quote.human[lineItem.mapping] }}</p>
          </div>
        </div>
      </div>
      <div class="product-summary-card padding-medium bg-surface-decorative text-white text-left margin-bottom-small">
        <h2 *ngIf="quote.covers.length > 0" class="margin-bottom-xxsmall text-surface-decorative-text">{{ quote.covers[0].label | titlecase }} {{ data.settings.callout.heading }}</h2>
        <h2 *ngIf="quote.covers.length === 0" class="margin-bottom-xxsmall text-surface-decorative-text">{{ quote.data[data.settings.callout.mapping] | titlecase }} {{ data.settings.callout.heading }}</h2>
        <div class="row align-middle">
          <div class="small-12 columns">
            <div class="flex-container align-middle margin-bottom-xxsmall">
              <open-price [price]="price" [precision]="precision" class="product-summary-price"></open-price>
            </div>
          </div>
        </div>
        <p class="strong text-surface-decorative-text margin-bottom-xxsmall">{{ data.settings.callout.subtext | stringInjection : arrang_fee }}</p>
      </div>
    </div>
  </div>
</div>